import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { clientsService } from '../services/api';
import { ClientModal } from '../components/ClientModal';
import { formatApptDate } from '../utils/dateFormatters';
import './Clients.css';

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(false);

  async function load() {
    setLoading(true);
    const res = await clientsService.getAll();
    if (res.success) setClients(res.customers || []);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  const filtered = clients.filter((c) => {
    const q = search.toLowerCase();
    return !q || [c.name, c.email, c.phone, c.address_suburb].some((v) => v?.toLowerCase().includes(q));
  });

  return (
    <div className="clients-page">
      <div className="page-header">
        <h1 className="page-title">Clients</h1>
        <button className="btn btn-primary" onClick={() => setModal(true)}>+ New Client</button>
      </div>

      <input className="clients-search" placeholder="Search clients…" value={search} onChange={(e) => setSearch(e.target.value)} />

      {loading ? (
        <div className="empty-state"><div className="loading-spinner"></div></div>
      ) : filtered.length === 0 ? (
        <div className="empty-state"><p>No clients found</p></div>
      ) : (
        <div className="card-grid">
          {filtered.map((c) => (
            <Link key={c.id} to={`/clients/${c.id}`} className="client-card">
              <h3>{c.name}</h3>
              {c.phone && <p className="text-muted">{c.phone}</p>}
              {c.email && <p className="text-muted client-email">{c.email}</p>}
              {c.address_suburb && <p className="text-muted">{c.address_suburb}</p>}
              <div className="client-meta">
                <span className="chip">{c.appointments_count || 0} appt{Number(c.appointments_count) === 1 ? '' : 's'}</span>
                {c.last_appointment_at && <span className="chip chip-muted">Last {formatApptDate(c.last_appointment_at)}</span>}
              </div>
            </Link>
          ))}
        </div>
      )}

      <ClientModal isOpen={modal} onClose={() => setModal(false)} onSave={() => { setModal(false); load(); }} />
    </div>
  );
}
